/**
 * Portal 前端配置
 * 与原版 index.html 中 window.PORTAL_CONFIG 保持一致
 */
export const PORTAL_CONFIG = {
  API_BASE: '',
  API_VERSION: '20260604',
  ADMIN_URL: '../admin/',
  TYPEWRITER_SPEED: 30,
  LICENSE_CHECK_URL: '',
  SITE_NAME: '',
  ASSISTANT_NAME: '',
  SITE_LOGO: 'logo-graphic.svg',
  SITE_DESCRIPTION: '',
  SITE_KEYWORDS: '',
  SITE_SUBTITLE: '',
  ICP_NUMBER: '',
  FOOTER_COPYRIGHT: '',
  WELCOME_TITLE: '',
  WELCOME_SUBTITLE: '',
  DISCLAIMER: 'AI生成内容仅供参考，不可作为法律证据或专业意见。请谨慎甄别信息。',
  HELP_URL: '#',
  DOWNLOAD_URL: '#',
  TERMS_URL: '#',
  PRIVACY_URL: '#',
}

// 动态覆盖：如果页面中存在同名 window 配置（CDN部署场景），优先使用页面配置
try {
  const win = window as any
  if (win.PORTAL_CONFIG) {
    Object.assign(PORTAL_CONFIG, win.PORTAL_CONFIG)
  }
} catch (_) {}

export default PORTAL_CONFIG
